import { render, staticRenderFns } from "./DeparturesPageCampinaGrande.vue?vue&type=template&id=1a5c9f23&"
import script from "./DeparturesPageCampinaGrande.vue?vue&type=script&lang=js&"
export * from "./DeparturesPageCampinaGrande.vue?vue&type=script&lang=js&"
import style0 from "./DeparturesPageCampinaGrande.vue?vue&type=style&index=0&id=1a5c9f23&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports